// @ts-nocheck
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { DealerStateContext } from "@insite/client-framework/Store/Data/Dealers/DealersSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "@toolkit/Framework/Common/Utilities/parseFullPageHtml";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import React, { useContext } from "react";
import { css } from "styled-components";

const enum fields {
    title = "title",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
    };
}

export interface DealerImageStyles {
    wrapper?: InjectableCss;
    nameText?: TypographyPresentationProps;
    content?: InjectableCss;
}

export const dealerImageStyles: DealerImageStyles = {
    nameText: {
        forwardAs: "h2",
        css: css`
            ${spacingStyles("1.25em", "0.25em")}
            ${({ theme }) => css`
                font-size: ${theme.design.typography.size.large};
                font-weight: ${theme.design.typography.weight.bold};
            `}
        `,
    },
    content: {
        css: css`
            table {
                width: 100% !important; /* to override styling in wysiwyg html */
                border: 0;
                border-color: transparent;
                border-spacing: 0;
                border-collapse: collapse;

                tr:nth-child(odd) {
                    background-color: ${getColor("common.accent")};
                }

                td {
                    padding: 1rem;
                }
            }
        `,
    },
};

const styles = dealerImageStyles;

const DealerAdditionalInformation = ({ fields: { title } }: OwnProps) => {
    const { value: dealer } = useContext(DealerStateContext);
    if (!dealer || !dealer.properties.content) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.nameText}>{title}</Typography>
            <StyledWrapper {...styles.content}>{parse(dealer.properties.content || "", parserOptions)}</StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: DealerAdditionalInformation,
    definition: {
        allowedContexts: ["DealerDetailsPage"],
        group: "Dealer Details",
        fieldDefinitions: [
            {
                name: fields.title,
                fieldType: "Translatable",
                editorTemplate: "TextField",
                defaultValue: "Additional Information",
                isRequired: true,
            },
        ],
    },
};

export default widgetModule;
